import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@styles';

// React SwipeableViews
import SwipeableViews from 'react-swipeable-views';

// Material-UI
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const MuiTabs = (props) => {
  const {
    children,
    ...restProps
  } = props;

  return (
    <Tabs
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      {...restProps}
    >
      {children}
    </Tabs>
  );
};

MuiTabs.propTypes = {
  // Tabs children, usually the included sub-components.
  children: PropTypes.node,
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

export const StyledTabs = withStyles(() => ({
  root: {
    width: '100%',
    marginBottom: '8px'
    // borderBottom: '1px solid colors.greyLight'
  },
  indicator: {
    height: '3px',
    borderRadius: '3px',
    backgroundColor: Theme.colors.blueMedium
  }
}))(MuiTabs);

export const StyledTabsSwipeable = styled(SwipeableViews)`
  padding: 8px;

  .react-swipeable-view-container {
    will-change: auto !important;
  }
`;

export const StyledTab = styled(Tab)`
  &.MuiTab-root {
    padding: 8px 24px;
    text-transform: initial;
  }

  &.MuiTab-textColorPrimary {
    color: ${(props) => props.theme.colors.greyDark};
  }

  &.MuiTab-textColorPrimary.Mui-selected {
    color: ${(props) => props.theme.colors.blueMedium};
  }

  & > span {
    font-family: 'Bryant Pro Regular';
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
  }
`;